import { differenceInMonths, isBefore, parse } from 'date-fns';

const MAX_PERIOD_MONTHS = 36;

// date-fns の parse は yyyy-MM フォーマットでは日・時刻成分を参照しないため、
// 第3引数は実行時の現在日時に依存させない固定値で良い。
const PARSE_REFERENCE = new Date(0);

// 入力契約: fromMonth / toMonth はともに 'yyyy-MM' 形式の文字列。
// 呼び出し側 (EventPeriodSelector) は MonthField で常に有効な月文字列を保証するため、
// 関数内で null / 空文字 / 不正フォーマットのガードは持たない。
//
// 「最長3年間」= 開始月から3年後の同月までを許容する。
// 両端を月数で数えると37ヶ月分になるが、ユーザーが「3年後の同月」を
// 指定したときに弾かれない入力UXを優先する。
export function validateEventPeriod(fromMonth, toMonth) {
  const from = parse(fromMonth, 'yyyy-MM', PARSE_REFERENCE);
  const to = parse(toMonth, 'yyyy-MM', PARSE_REFERENCE);
  return !isBefore(to, from) && differenceInMonths(to, from) <= MAX_PERIOD_MONTHS;
}
